import angular from 'angular';

import component from './additional-field.component';

const AdditionalField = angular
    .module('control-room.experience-promoter.components.experience-manage.components.additional-field', [])
    .component('crAdditionalField', component);

export default AdditionalField;
